import React from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import { Link } from "react-router-dom"; // Use react-router-dom Link

const Footer = () => {
  return (
    <footer className="footer-cerse">
      <Container fluid>
        <Row className="py-5 px-2 border-top">
          <Col md={4} className="mt-5 mt-lg-0">
            <img
              src="https://branding.vcu.edu/bar/academic/images/vcu-simple-seal--primary.svg"
              alt="VCU SPH Logo"
              className="img-fluid w-50"
            />

            <Nav className="flex-column">
              <Nav.Item>
                <Nav.Link as={Link} to="#" className="nav-link-sph">
                  <h4>Virginia Commonwealth University</h4>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="#"
                  className="nav-link-sph"
                  style={{ color: "#ffb300" }}
                >
                  <h6> School of Public Health</h6>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="#" className="nav-link-sph">
                  <h6> Department of Epidemiology</h6>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>

          <Col md={2} className="mt-5 mt-lg-0">
            <div>
              <p className="fw-bold">
                VCU Medical Center West Hospital <br />
              </p>
              VCU West Hospital <br />
              Room 3-112 <br />
              1200 E Broad St <br /> Richmond, VA 23219 <br />
              <br />
              Phone: 804-827-9692
              <br />
              Email:{" "}
              <a className="nav-link-sph" href="mailto:herostudy@vcu.edu">
                herostudy@vcu.edu{" "}
              </a>
            </div>
          </Col>

          <Col md={2} className="mt-5 mt-lg-0">
            <h5>More</h5>
            <Nav as="ul" className="flex-column">
              <Nav.Item as="li">
                <Nav.Link
                  as={Link}
                  to={"https://clinicaltrials.gov/study/NCT07071350"}
                  className="nav-link-sph"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ClinicalTrials.gov
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="https://www.vcu.edu/privacy-statement/"
                  className="nav-link-sph"
                >
                  Privacy
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li">
                <Nav.Link
                  as={Link}
                  to="https://accessibility.vcu.edu/"
                  className="nav-link-sph"
                >
                  Accessibility
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li">
                <Nav.Link
                  as={Link}
                  to="mailto:webmaster@vcu.edu"
                  className="nav-link-sph"
                >
                  Webmaster
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li">
                <Nav.Link
                  as={Link}
                  target="_blank"
                  to="https://redcap.vcu.edu/"
                  className="nav-link-sph"
                >
                  REDCap
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li">
                <Nav.Link as={Link} className="nav-link-sph">
                  <p>Updated On: {process.env.REACT_APP_BUILD_TIME}</p>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
        </Row>

        <div>
          <Row>
            <Container>
              <div className="py-2 text-center fst-italic">
                Virginia Commonwealth University is a nationally renowned public
                research institution dedicated to the success and well-being of
                all members of its community. VCU student, faculty and staff
                groups and associations are open without regard to any
                characteristic or identity protected by law.
              </div>
            </Container>
          </Row>
          <Row>
            <Container>
              <div className="py-2 text-center">
                Created by Information Science and Technology - Department of
                Physical Medicine & Rehabilitation - VCU School of Medicine (
                <a
                  href="https://pmr.vcu.edu/"
                  className="nav-link-sph"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://pmr.vcu.edu/
                </a>
                )
              </div>
            </Container>
          </Row>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
